import { GRANT_PROGRAMS } from "./grantProgramData";

export default function GrantProgramMatrix() {
  return (
    <div className="overflow-x-auto rounded-xl border border-border">
      <table className="w-full min-w-[900px] text-left text-sm">
        <caption className="sr-only">
          Federal, national, nonprofit, and lender assistance programs for low-income first-time home buyers
        </caption>
        <thead className="bg-muted/60">
          <tr>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">Program</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">Provider</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">Geography</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">Income rule</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">First-time rule</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">Education</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">Type</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">Last checked</th>
          </tr>
        </thead>
        <tbody>
          {GRANT_PROGRAMS.map((p) => (
            <tr key={p.id} className="border-t border-border align-top">
              <th scope="row" className="px-4 py-3 font-semibold text-foreground">{p.name}</th>
              <td className="px-4 py-3 text-muted-foreground">{p.provider}</td>
              <td className="px-4 py-3 text-muted-foreground">{p.geography_scope}</td>
              <td className="px-4 py-3 text-muted-foreground">{p.income_basis}</td>
              <td className="px-4 py-3 text-muted-foreground">{p.first_time_rule}</td>
              <td className="px-4 py-3 text-muted-foreground">{p.education_required}</td>
              <td className="px-4 py-3">
                <span className="inline-block rounded-full border border-primary/40 bg-primary/10 px-2 py-0.5 text-xs font-semibold text-primary">
                  {p.assistance_type}
                </span>
              </td>
              <td className="px-4 py-3 text-muted-foreground">{p.source_last_checked}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}